/**
 * useGamePhase — hook pour lire la phase courante du game-shell.
 *
 * Doit être appelé à l'intérieur d'un `<GameShell>` provider.
 *
 * Retourne la phase courante + des booleans dérivés (isIntro, isStaircase, etc.)
 * pour rendu conditionnel propre dans `<PhaseRenderer>` et co.
 */
import { useContext, useMemo } from 'react';
import { useSyncExternalStore } from 'react';
import { GameShellContext } from './context';
export function useGamePhase() {
    const ctrl = useContext(GameShellContext);
    if (!ctrl) {
        throw new Error('[game-shell] useGamePhase must be used inside <GameShell>');
    }
    const subscribe = useMemo(() => (notify) => ctrl.subscribe(() => notify()), [ctrl]);
    const getSnapshot = useMemo(() => () => ctrl.getSnapshot().phase, [ctrl]);
    const phase = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
    return useMemo(() => ({
        phase,
        isIntro: phase === 'intro',
        isDemo: phase === 'demo',
        isCalibrationWarmup: phase === 'calibration_warmup',
        isStaircase: phase === 'staircase',
        isWrapUp: phase === 'wrap_up',
        isDebrief: phase === 'debrief',
        isPaused: phase === 'paused',
        isAborted: phase === 'aborted',
    }), [phase]);
}
//# sourceMappingURL=useGamePhase.js.map